module.exports = __webpack_public_path__ + "static/img/kpsl.a0660475.png";